module.exports = __webpack_public_path__ + "media/images/landing-pages/lp-sec-crs-3-6cca83053999199a0cec9e5609b6c460.png";